
import { baseUri } from '../config'

export const getProjects = `${baseUri}projects`